import React from 'react';
import { Link } from 'react-router-dom';
import { Page } from 'UI';
import { Newsletter } from 'Components';

import './NewsletterPage.scss';

export default function NewsletterPage() {
  return (
    <Page id="NewsletterPage">
      <Newsletter withLogo={true} />
      <div className="legal">
        <Link to="/protection-des-donnees">
          Politique de Protection des Données
        </Link>
        <Link to="/cgu">Conditions Générales d'Utilisation</Link>
      </div>
    </Page>
  );
}
